import React from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {Checkbox} from "semantic-ui-react";
import { Icon, Popup } from 'semantic-ui-react';
import {Link} from "react-router-dom";
import MARVEL from "../../../common/utils/MarvelUrls";
import {countriesListFormatter} from "../../../common/utils/CountriesListFormatter";
import {DPSortFields} from "../constants/DataProviderActionConstants";

export class DataProvidersListRow extends React.Component {

    static propTypes = {
        key: PropTypes.number,
        providerID: PropTypes.string,
        providerName: PropTypes.string,
        isApproved: PropTypes.number,
        associatedServices: PropTypes.number,
        associatedSources: PropTypes.number,
        associatedCountries: PropTypes.array,
    }

    get checkbox() {
        return (
            <td className="low-width">
                <Checkbox
                    disabled
                    checked={this.props.isSelected}
                />
            </td>
        );
    }

    get isApproved() {
        const { isApproved } = this.props;
        return (
            <td className="low-width">
                {isApproved
                    ? null
                    : (<Popup
                        content='Provider Not Verified'
                        trigger={<Icon color="orange" name="warning sign"/>}
                    />)
                }
            </td>
        );
    }

    get providerName() {
        const { providerID, providerName, associatedCountries, dpSortKey } = this.props;
        const countriesList = countriesListFormatter(associatedCountries)
        let classnames = ""
        if (dpSortKey === DPSortFields.PROVIDER_NAME) {
            classnames += "current-sort"
        }
        return (
            <td className={classnames}>
                <Link to={{pathname: MARVEL.VERITAS.data_providers + providerID}} key={providerID}>
                    <p className="provider-name">
                        <b>{providerName}</b>
                    </p>
                    <p className="provider-country">
                        {countriesList}
                    </p>
                </Link>
            </td>
        );
    }

    get associatedDPServices() {
        const { associatedServices } = this.props;
        return (
            <td>
                <p>
                    <b>{associatedServices}</b>
                </p>
            </td>
        );
    }

    get associatedDPSources() {
        const { associatedSources } = this.props;
        return (
            <td>
                <p>
                    <b>{associatedSources}</b>
                </p>
            </td>
        );
    }


    render() {

        return (
            <tr>
                {this.checkbox}
                {this.isApproved}
                {this.providerName}
                {this.associatedDPServices}
                {this.associatedDPSources}
            </tr>
        )
    }
}

const mapStateToProps = (state) => ({
    dpSortKey: state.veritas.providers.dpSortKey,
});

const mapDispatchToProps = dispatch => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DataProvidersListRow)
